export default __webpack_public_path__ + "static/media/nemo.26eddbe1.jpg";